(function () {
  'use strict';

  var sectionEl = document.querySelector('[data-flapp-pos-id]');
  var FLAPP_POS_ID = sectionEl?.dataset.flappPosId || '';
  var FLAPP_BASE_URL = sectionEl?.dataset.flappBaseUrl || 'https://api.weflapp.com';
  var GOOGLE_MAPS_KEY = sectionEl?.dataset.googleMapsKey || '';
  var SAMPLE_SKU = sectionEl?.dataset.flappSampleSku || '';
  var SAMPLE_PRICE = parseInt(sectionEl?.dataset.flappSamplePrice, 10) || 0;

  // Pool of SKUs from the collection used to probe Flapp's coverage. Flapp's
  // public-rates only returns express rates from locales that physically have
  // the SKU we ask about. If we probe with a single SKU and that variant is
  // out of stock at every Flapp locale near the customer, the API returns
  // zero express rates and we'd falsely report the zone as uncovered. By
  // probing multiple SKUs we treat the zone as covered as soon as ANY SKU
  // hits at least one express locale.
  var SAMPLE_SKUS = (sectionEl?.dataset.flappSampleSkus || '')
    .split(',')
    .map(function (s) { return s.trim(); })
    .filter(Boolean);
  if (SAMPLE_SKUS.length === 0 && SAMPLE_SKU) {
    SAMPLE_SKUS = [SAMPLE_SKU];
  }

  // Flapp LocalId → Shopify Location ID mapping
  var LOCALS_MAP = {
    '1927': '73457303625',
    '1926': '73457467465',
    '1923': '111367225417',
    '1925': '73456877641',
    '1924': '73457500233',
    '2037': '111367290953',
    '2038': '73456975945',
    '2039': '73457205321',
    '2040': '73457401929',
    '2041': '73457434697'
  };

  var addressBar = document.getElementById('flapp-address-bar');
  var addressBarText = document.getElementById('flapp-address-bar-text');
  var addressBarCta = document.getElementById('flapp-address-bar-cta');
  var addressBarChange = document.getElementById('flapp-address-bar-change');
  var addressBarClear = document.getElementById('flapp-address-bar-clear');
  var modal = document.getElementById('flapp-modal');
  var modalOverlay = document.getElementById('flapp-modal-overlay');
  var modalClose = document.getElementById('flapp-modal-close');
  var form = document.getElementById('flapp-address-form');
  var submitBtn = document.getElementById('flapp-submit');
  var loadingEl = document.getElementById('flapp-loading');
  var errorEl = document.getElementById('flapp-error');

  if (!addressBar) return;

  // ── Product grid state ──
  var productGrid = document.querySelector('product-list');
  // Active run for the dynamic product loader. Any new startProductFiltering()
  // call must cancel the previous one to avoid concurrent loops racing on
  // shared state (which used to deadlock the event loop).
  var activeRun = null;

  // ── State restore ──
  var savedAddress = sessionStorage.getItem('flapp_address');
  var savedLocationIds = sessionStorage.getItem('flapp_location_ids');

  if (savedAddress && savedLocationIds) {
    showConfirmedState(savedAddress);
    startProductFiltering();
  } else {
    showCtaState();
    // Auto-open the address modal on first visit to the collection so the
    // customer is prompted immediately to verify express coverage.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openModal, { once: true });
    } else {
      openModal();
    }
  }

  // ── Open / close modal ──
  function openModal() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    errorEl.style.display = 'none';
    var firstInput = form.querySelector('input');
    if (firstInput) firstInput.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // ── Clear address ──
  function clearAddress() {
    sessionStorage.removeItem('flapp_address');
    sessionStorage.removeItem('flapp_location_ids');
    sessionStorage.removeItem('flapp_rate_id');
    showCtaState();
    form.reset();
    showPagination();
    // Reload page to restore normal collection view
    window.location.reload();
  }

  addressBarCta.addEventListener('click', openModal);
  addressBarChange.addEventListener('click', function (e) {
    e.preventDefault();
    openModal();
  });
  if (addressBarClear) {
    addressBarClear.addEventListener('click', function (e) {
      e.preventDefault();
      clearAddress();
    });
  }
  modalOverlay.addEventListener('click', closeModal);
  modalClose.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // ── Google Places Autocomplete ──
  var address1Input = document.getElementById('flapp-address1');
  var communeInput = document.getElementById('flapp-commune');
  var autocomplete = null;

  // Clear the (read-only) commune whenever the user edits the street again,
  // so stale autocomplete values don't leak into the next submit.
  if (address1Input) {
    address1Input.addEventListener('input', function () {
      if (communeInput) communeInput.value = '';
    });
  }

  function initAutocomplete() {
    if (!GOOGLE_MAPS_KEY || !window.google?.maps?.places) return;

    autocomplete = new google.maps.places.Autocomplete(address1Input, {
      types: ['address'],
      componentRestrictions: { country: 'cl' },
      fields: ['address_components', 'formatted_address']
    });

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place || !place.address_components) return;

      var streetNumber = '';
      var route = '';
      var commune = '';

      for (var i = 0; i < place.address_components.length; i++) {
        var comp = place.address_components[i];
        var types = comp.types;

        if (types.indexOf('street_number') !== -1) {
          streetNumber = comp.long_name;
        } else if (types.indexOf('route') !== -1) {
          route = comp.long_name;
        } else if (types.indexOf('locality') !== -1) {
          commune = comp.long_name;
        } else if (!commune && types.indexOf('administrative_area_level_3') !== -1) {
          commune = comp.long_name;
        }
      }

      if (route) {
        address1Input.value = route + (streetNumber ? ' ' + streetNumber : '');
      }

      if (communeInput) {
        communeInput.value = commune || '';
      }
    });
  }

  if (GOOGLE_MAPS_KEY) {
    if (window.google?.maps?.places) {
      initAutocomplete();
    } else {
      var checkInterval = setInterval(function () {
        if (window.google?.maps?.places) {
          clearInterval(checkInterval);
          initAutocomplete();
        }
      }, 200);
      setTimeout(function () { clearInterval(checkInterval); }, 10000);
    }
  }

  // ── Form submit ──
  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    var address1 = form.querySelector('[name="address1"]').value.trim();
    var commune = form.querySelector('[name="commune"]').value.trim();

    if (!address1 || !commune) {
      errorEl.textContent = 'Selecciona tu dirección desde las sugerencias para completar la comuna.';
      errorEl.style.display = 'block';
      return;
    }

    submitBtn.disabled = true;
    loadingEl.style.display = 'flex';
    errorEl.style.display = 'none';

    if (!FLAPP_POS_ID) {
      errorEl.textContent = 'Error de configuración: falta el Point of Sale ID de Flapp';
      errorEl.style.display = 'block';
      submitBtn.disabled = false;
      loadingEl.style.display = 'none';
      return;
    }

    // Flapp's public-rates requires at least one item; an empty `items` array
    // makes them skip the rate calculation entirely. The field name MUST be
    // `amount` (not `quantity`) — Flapp's backend casts unknown fields to NaN
    // and crashes the SQL query that resolves active rates.
    //
    // We probe with several SKUs because Flapp only returns express rates
    // from locales that actually stock the queried SKU. Stopping after the
    // first SKU produced false negatives whenever that one variant happened
    // to be out of stock at every nearby locale.
    var skusToProbe = SAMPLE_SKUS.length > 0 ? SAMPLE_SKUS : ['CHECK'];

    try {
      var expressRates = [];
      var lastErrorMsg = '';
      var anyResponseOk = false;

      for (var s = 0; s < skusToProbe.length; s++) {
        var probeItem = { sku: skusToProbe[s], amount: 1, price: 5000 };

        var response = await fetch(
          FLAPP_BASE_URL + '/integrations/generic/public-rates',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              pointOfSaleId: FLAPP_POS_ID,
              communeId: null,
              shippingAddress: {
                address1: address1,
                commune: commune
              },
              items: [probeItem]
            })
          }
        );

        var data = await response.json();

        if (!response.ok) {
          lastErrorMsg = data.message || 'Lo sentimos, aún no llegamos a tu zona';
          continue;
        }

        anyResponseOk = true;
        var rates = Array.isArray(data) ? data : (data.rates || []);
        var found = rates.filter(function (r) { return r.shippingType === 'express'; });
        if (found.length > 0) {
          expressRates = found;
          break;
        }
      }

      if (expressRates.length > 0) {
        var shopifyLocationIds = [];
        expressRates.forEach(function (rate) {
          var localId = String(rate.LocalId);
          var shopifyId = LOCALS_MAP[localId];
          if (shopifyId && shopifyLocationIds.indexOf(shopifyId) === -1) {
            shopifyLocationIds.push(shopifyId);
          }
        });

        saveAddressToCart(address1, commune);

        sessionStorage.setItem('flapp_address', commune);
        sessionStorage.setItem('flapp_location_ids', JSON.stringify(shopifyLocationIds));
        sessionStorage.setItem('flapp_rate_id', expressRates[0].id || '');

        showConfirmedState(commune);
        closeModal();
        startProductFiltering();
      } else if (!anyResponseOk && lastErrorMsg) {
        errorEl.textContent = lastErrorMsg;
        errorEl.style.display = 'block';
      } else {
        errorEl.textContent = 'Lo sentimos, aún no llegamos a tu zona con envío express';
        errorEl.style.display = 'block';
      }
    } catch (err) {
      errorEl.textContent = 'Lo sentimos, ocurrió un error. Intenta de nuevo.';
      errorEl.style.display = 'block';
    } finally {
      submitBtn.disabled = false;
      loadingEl.style.display = 'none';
    }
  });

  // ══════════════════════════════════════════════
  // Dynamic product loading with stock filtering
  // ══════════════════════════════════════════════

  function cancelActiveRun() {
    if (!activeRun) return;
    activeRun.cancelled = true;
    try { activeRun.abort.abort(); } catch (e) {}
    activeRun = null;
  }

  function startProductFiltering() {
    // Always re-query — Shopify's native facet re-render replaces <product-list>
    // with a new DOM node, so any previous reference is stale.
    productGrid = document.querySelector('product-list');
    if (!productGrid) return;

    var locationIds = JSON.parse(sessionStorage.getItem('flapp_location_ids') || '[]');
    if (locationIds.length === 0) return;

    // Cancel any in-flight loader before starting a new one. This frees the
    // event loop from the previous while-loop and aborts its pending fetches.
    cancelActiveRun();

    // Clear existing products
    productGrid.innerHTML = '';

    // Hide pagination and product count (they belong to the unfiltered collection)
    hidePagination();

    // Build a run-scoped state object so concurrent runs can never share state.
    var run = {
      cancelled: false,
      abort: new AbortController(),
      grid: productGrid,
      locationIds: locationIds,
      currentPage: 1,
      loadedProductIds: Object.create(null)
    };
    activeRun = run;

    loadAllPages(run);
  }

  function hidePagination() {
    document.querySelectorAll('.pagination, [class*="pagination"], .collection__pagination').forEach(function (el) {
      el.style.display = 'none';
    });
    // Also hide the product count which shows unfiltered total
    document.querySelectorAll('.collection__results-count, [data-products-count]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function showPagination() {
    document.querySelectorAll('.pagination, [class*="pagination"], .collection__pagination').forEach(function (el) {
      el.style.display = '';
    });
    document.querySelectorAll('.collection__results-count, [data-products-count]').forEach(function (el) {
      el.style.display = '';
    });
  }

  async function loadAllPages(run) {
    // Each iteration MUST await a real fetch (not a synchronous early-return
    // promise), otherwise the microtask queue would starve the event loop.
    while (!run.cancelled) {
      var done = await loadPage(run);
      if (run.cancelled || done) break;
    }
    if (activeRun === run) activeRun = null;
  }

  async function loadPage(run) {
    // Returns true when there is no more work to do (last page, error, empty).
    var pathParts = window.location.pathname.split('/');
    var collectionHandle = pathParts[pathParts.indexOf('collections') + 1];
    if (!collectionHandle) return true;

    // Forward Shopify's native filter params (filter.v.*, filter.p.*, sort_by, q, ...)
    // to the flapp-products template so `collection.products` returns the same
    // filtered subset the customer asked for via facets-form.
    var params = new URLSearchParams(window.location.search);
    params.delete('view');
    params.delete('page');
    params.delete('section_id');
    params.set('view', 'flapp-products');
    params.set('page', String(run.currentPage));

    var url = '/collections/' + collectionHandle + '?' + params.toString();

    var data;
    try {
      var response = await fetch(url, { credentials: 'same-origin', signal: run.abort.signal });
      if (run.cancelled) return true;
      var text = await response.text();
      if (run.cancelled) return true;
      data = JSON.parse(text);
    } catch (e) {
      return true;
    }

    if (!data || !data.items || data.items.length === 0) return true;

    for (var i = 0; i < data.items.length; i++) {
      if (run.cancelled) return true;

      var product = data.items[i];
      if (run.loadedProductIds[product.id]) continue;

      // Stock check (variant metafield `custom.inventory_locations`):
      //   { "<shopifyLocationId>": { variantId, externalId, quantity, local, hasStock }, ... }
      // A location is considered "with stock" only when quantity >= 2.
      var stockData = product.stock_by_location || {};
      var hasStock = false;
      for (var j = 0; j < run.locationIds.length; j++) {
        var entry = stockData[run.locationIds[j]];
        if (!entry) continue;
        if (typeof entry.quantity === 'number' && entry.quantity >= 2) {
          hasStock = true;
          break;
        }
      }
      if (!hasStock) continue;

      try {
        var cardResponse = await fetch(
          '/products/' + product.handle + '?section_id=flapp-product-card',
          { credentials: 'same-origin', signal: run.abort.signal }
        );
        if (run.cancelled) return true;
        var cardHtml = await cardResponse.text();
        if (run.cancelled) return true;

        var parser = new DOMParser();
        var doc = parser.parseFromString(cardHtml, 'text/html');
        var cardWrapper = doc.querySelector('.flapp-product-card-wrapper');
        if (cardWrapper) {
          var productCard = cardWrapper.querySelector('product-card');
          if (productCard) {
            run.grid.appendChild(productCard);
            run.loadedProductIds[product.id] = true;
          }
        }
      } catch (e) {
        if (e && e.name === 'AbortError') return true;
      }
    }

    // Advance; stop when we have exhausted the paginator.
    if (run.currentPage >= data.pages) return true;
    run.currentPage++;
    return false;
  }

  // ── Save address to cart for checkout ──
  function saveAddressToCart(address1, commune) {
    var code = 'checkout[shipping_address][country]=CL'
      + '&checkout[shipping_address][address1]=' + encodeURIComponent(address1)
      + '&checkout[shipping_address][city]=' + encodeURIComponent(commune);

    fetch('/cart?' + code, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/js' }
    }).catch(function () {});
  }

  // ── UI state helpers ──
  function showConfirmedState(commune) {
    addressBarText.innerHTML =
      '<svg class="flapp-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1C6.13 1 3 4.13 3 8c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 10 5.5a2.5 2.5 0 0 1 0 5z" fill="currentColor"/></svg>' +
      '<span>Envío express disponible a <strong>' + escapeHtml(commune) + '</strong></span>';
    addressBarCta.style.display = 'none';
    addressBarChange.style.display = 'inline';
    if (addressBarClear) addressBarClear.style.display = 'inline';
  }

  function showCtaState() {
    addressBarText.innerHTML =
      '<svg class="flapp-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1C6.13 1 3 4.13 3 8c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 10 5.5a2.5 2.5 0 0 1 0 5z" fill="currentColor"/></svg>' +
      '<span>Verifica si llegamos a tu dirección con envío express</span>';
    addressBarCta.style.display = 'inline-flex';
    addressBarChange.style.display = 'none';
    if (addressBarClear) addressBarClear.style.display = 'none';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // ══════════════════════════════════════════════
  // Re-filter on Shopify native facet changes
  // ══════════════════════════════════════════════
  // When the customer ticks a filter inside <facets-form>, the theme fires a
  // `facet:update` event on the document and (asynchronously) replaces the
  // <product-list> DOM with the filtered section HTML. If express delivery
  // is active, we re-run our filter on top of that so the grid shows only
  // products that match BOTH the native filters and the stock availability
  // at the matched express locations.
  document.addEventListener('facet:update', function () {
    if (!sessionStorage.getItem('flapp_location_ids')) return;
    // Cancel the in-flight loader IMMEDIATELY so it stops appending cards
    // to the <product-list> that the theme is about to replace, and so the
    // while-loop can't race with the new one we are about to start.
    cancelActiveRun();
    // Wait for the theme to finish fetching and replacing the section DOM.
    // Same 600ms delay pattern as sections/collection-filter-horizontal.liquid.
    setTimeout(function () {
      if (!sessionStorage.getItem('flapp_location_ids')) return;
      startProductFiltering();
    }, 600);
  });
})();
